import { render, staticRenderFns } from "./UserApplicationModel.vue?vue&type=template&id=1b31cf02&scoped=true&"
import script from "./UserApplicationModel.vue?vue&type=script&lang=js&"
export * from "./UserApplicationModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b31cf02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b31cf02')) {
      api.createRecord('1b31cf02', component.options)
    } else {
      api.reload('1b31cf02', component.options)
    }
    module.hot.accept("./UserApplicationModel.vue?vue&type=template&id=1b31cf02&scoped=true&", function () {
      api.rerender('1b31cf02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/UserApplicationModel.vue"
export default component.exports